import { CatalogListItemSimpleModel, CatalogListWithItemsModel } from "api";

export function decapitalize(str?: string) {
    return str ? str.charAt(0).toLowerCase() + str.slice(1) : "";
}

function inputPropsNamesToLowerCase(item: { inputProps: { name: string | undefined } }) {
    return { ...item, inputProps: { ...item.inputProps, name: decapitalize(item.inputProps.name) } };
}

function decapitalizeItems(item: CatalogListItemSimpleModel) {
    const propertyName = decapitalize(item.propertyName);
    const itemEntityOptions = (item.itemEntityOptions || []).map(({ id, propertyName }) => {
        propertyName = decapitalize(propertyName);
        return { id, propertyName };
    });
    return { ...item, propertyName, itemEntityOptions };
}

function reduceCatalogFormConfig(
    acc: { [x: string]: { id: number; value: { inputProps: { name: string } }[] }[] },
    catalog: CatalogListItemSimpleModel,
    propertyName: string,
    arr: CatalogListWithItemsModel[],
) {
    const formattedOptions = (catalog.itemEntityOptions || []).map((option) => {
        const { valueClrType, displayName, propertyName, valueCatalogType } = option;
        const formatted: {
            label: string | undefined;
            inputProps: { name: string | undefined; type: "text" | "select" | "number" };
            options?: { label: string | undefined; value: number }[];
        } = {
            label: displayName,
            inputProps: { name: propertyName, type: "text" },
        };
        const select = arr.find((arrItem) => !arrItem.externalId && arrItem.type === valueCatalogType);
        if (select) {
            formatted.inputProps.type = "select";
            formatted.options = (select.items || []).map((arrItem) => ({
                label: arrItem.displayName,
                value: arrItem.id,
            }));
        } else if (valueClrType === "Double" || valueClrType === "Int32") {
            formatted.inputProps.type = "number";
        }
        return formatted;
    });
    const nextItem = { id: catalog.id, value: formattedOptions.map(inputPropsNamesToLowerCase) };
    Array.isArray(acc[propertyName]) ? acc[propertyName].push(nextItem) : (acc[propertyName] = [nextItem]);
    return acc;
}

export function formatCatalog(item: CatalogListWithItemsModel, _i: number, arr: CatalogListWithItemsModel[]) {
    const propertyName = decapitalize(item.propertyName);
    const config = (item.items || []).reduce(
        (acc, catalog) => reduceCatalogFormConfig(acc, catalog, propertyName, arr),
        {} as { [x: string]: { id: number; value: { inputProps: { name: string } }[] }[] },
    );
    const enums = (item.items || []).reduce(
        (acc, item) => {
            if (!item.isDeleted) {
                acc.push({
                    label: item.displayName,
                    value: item.id,
                    isHidden: item.isHidden,
                    options: config[propertyName],
                    itemOptions: item.options,
                });
            }
            return acc;
        },
        [] as { label: string | undefined; value: number; isHidden: boolean; options: any; itemOptions: {} }[],
    );
    const items = (item.items || []).map(decapitalizeItems);
    return { ...item, items, propertyName, enums, config };
}

export function calcNextState(items: CatalogListWithItemsModel[]) {
    const formatted = items.map(formatCatalog);
    const enums = formatted.reduce(
        (acc, item) => Object.assign(acc, { [item.propertyName as string]: item.enums }),
        {},
    );
    return { items, enums, count: items.length };
}
